export const getExcludedTableFields = () => {
  return ["assignee", "actions", "task", "tags", "created", "source", "form"];
};
